import React, { useMemo } from "react";
import classNames from "classnames";


interface StraightArrowIconProps {
    className?: string;
    direction?: "up" | "down" | "left" | "right";
}

const StraightArrowIcon: React.FC<StraightArrowIconProps> = (props) => {
    const {
        className: propsClassName = "stroke-white size-3.5",
        direction = "down"
    } = props;

    const directionClassname = useMemo(() => {
        switch (direction) {
            case "up":
                return "rotate-270";
            case "down":
                return "rotate-90";
            case "left":
                return "rotate-180";
            case "right":
                return "rotate-0";
        }
    }, [direction]);

    return (
        <svg className={classNames(propsClassName, directionClassname)}
             width="14" height="14" viewBox="0 0 14 14"
             fill="none" xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M4 7H10.75M10.75 7L7.75 4M10.75 7L7.75 10" strokeWidth="1.3"
                  strokeLinecap="round" strokeLinejoin="round"
            />
        </svg>
    );
};

export default StraightArrowIcon;